<template>
  <v-dialog
    persistent
    v-bind="[$attrs, $props]"
    content-class="base__modal pa-10"
    width="800"
  >
    <div class="d-flex justify-space-between align-baseline mb-8">
      <h3 class="primary--text">
        INCLUIR RELACIONAMENTO SEGURADORA
      </h3>
      <v-btn text @click="$emit('close')">
        <v-icon class="fa dialog__close-btn">fa-times</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <label class="form__label primary--text">
          Buscar
        </label>
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          text-placeholder="Buscar"
        />
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="headers"
          :items="items"
          :search="search"
          item-key="nome"
          v-model="selected"
          show-select
        >
        </BaseDataTable>
      </v-col>
      <v-col cols="12" class="d-flex justify-end mt-6">
        <BaseButton
          text
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          @click="submit"
        >
          Adicionar
        </BaseButton>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import _ from "lodash";
const tableHeaders = [
  { text: "Nome", value: "nome", sortable: false },
  { text: "E-mail", value: "email", sortable: false },
  { text: "Telefone", value: "telefone1", sortable: false },
  { text: "Departamento", value: "departamento", sortable: false }
];
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon mt-2",
  "append-outer-icon": "fa-search"
};
export default {
  name: "SelectContactInsuranceModal",
  props: {
    items: Array,
    currentItems: [Object, Array]
  },
  data() {
    return {
      search: null,
      selected: [],
      headers: tableHeaders,
      filterProps: defaultFilterProps
    };
  },
  created() {
    this.selected = this.currentItems ? _.cloneDeep(this.currentItems) : [];
  },
  methods: {
    submit() {
      this.$emit("select-contacts-insurance", this.selected);
    }
  }
};
</script>
